import { type ReactNode } from 'react'
import { PreferencesProvider } from '@rammetec/app-kit/preferences'
import { useCurrentUser, useSessionContext } from '@vectorhub/application'
import { preferencesService } from '@/services/preferences.bootstrap'

/**
 * Mounts `PreferencesProvider` only when a user is present so hydrate / persist
 * run, and `service.reset()` fires on logout (provider unmount).
 *
 * `userId` comes from `useCurrentUser` — `useSessionContext` does not expose it.
 */
export function PreferencesBridge({ children }: { children: ReactNode }) {
  const { user } = useCurrentUser()
  const { currentOrgId } = useSessionContext()
  const userId = user?.userId

  if (!userId) {
    return children
  }

  return (
    <PreferencesProvider
      service={preferencesService}
      product="vh"
      userId={userId}
      orgId={currentOrgId ?? undefined}
    >
      {children}
    </PreferencesProvider>
  )
}
